import { Skeleton } from 'antd'
import React from 'react'
import { styled } from 'styled-components'

const Container = styled.div`
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
`

const SidebarSkeleton = styled(Skeleton).attrs({ active: true })`
  height: 100%;
  width: 100%;
  padding: 1rem;
`
export const SiteViewContentSkeleton = () => {
  return (
    <Container>
      <SidebarSkeleton />
      <MapSkeleton />
    </Container>
  )
}

export const MapSkeleton = styled(Skeleton.Image).attrs({
  // this height and width set the bounding height/width
  style: {
    height: '100%',
    width: '100%',
  },
  active: true,
})`
  // this height and width set the 'active' animation container height/width
  height: 100%;
  width: 100%;
  min-width: 100%;
  min-height: 100%;
`
